module.exports = __webpack_public_path__ + "img/half3.1a72364.png";